import angular from 'angular';

class ImagesService {
    constructor(config, dataService) {
        this.config = config;
        this.dataService = dataService;
    }

    getFullUrl(imageName) {
        return this.config.imagesUrl + imageName;
    }

    getCaptionImageUrl(fieldName, type) {
        const selectedOption = this.dataService.getSelectedOption(fieldName, type);

        return selectedOption === null ? '' : this.getFullUrl(selectedOption.attributes.captionImgSrc);
    }

    getImageUrl(fieldName, type) {
        const selectedOption = this.dataService.getSelectedOption(fieldName, type);
        return !selectedOption ? '' : this.getFullUrl(selectedOption.attributes.imgSrc);
    }

    getPaletteIconUrl(fieldName, type) {
        const selectedOption = this.dataService.getSelectedOption(fieldName, type);
        const paletteId = selectedOption.attributes.paletteId;
        const palettes = this.dataService.getColorPalettes();
        const palette = palettes.find(elem => elem.id === paletteId);

        return this.getFullUrl(palette.icon);
    }
}

ImagesService.$inject = ['config', 'dataService'];

export default angular.module('imagesService', [])
    .service('imagesService', ImagesService)
    .name;